import type { CommandsGroupInterface, UICommandInterface } from '@nts/std/interfaces';
import { BaseCommandItem } from './base-command-item';

export class CommandsGroup extends BaseCommandItem implements CommandsGroupInterface {
    commands: Array<UICommandInterface> = new Array<UICommandInterface>();

    constructor(name: string, displayName: string) {
        super(name, displayName);
    }

    addCommand(command: UICommandInterface) {
        this.commands.push(command);
    }
}
